// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__W89Mk","content":"styles_content__p12AL","selectAll":"styles_selectAll__KL6EQ"};